import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const HomeScreen = React.lazy(() => import('.'));

export const homeScreenRoutes = [
  new Route({
    path: 'home-screen',
    element: HomeScreen,
    children: [],
  }),
];
